import FormBuilderExternalResources from "./FormBuilderV2/FormBuilderApi/form_builder_external_resources";
export default {
  FormBuilderExternalResources
};
